import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { getUrl } from 'aws-amplify/storage';
import { useUserContext } from '../contexts/UserContext';

const DEFAULT_LOGO = '/logo-images/teiq-logo.png';

/**
 * Resolves the company logo URL the same way LeftNavigation does
 * (S3 public path → signed URL, otherwise stored URL / default asset).
 */
export function useCompanyLogo() {
    const { company } = useUserContext();
    const [companyLogo, setCompanyLogo] = useState(DEFAULT_LOGO);

    useEffect(() => {
        let isCancelled = false;

        const resolveLogo = async () => {
            const logo = company?.logo;
            if (!logo) {
                if (!isCancelled) setCompanyLogo(DEFAULT_LOGO);
                return;
            }

            if (logo.split('/')[0] === 'public') {
                try {
                    const photoUrl = await getUrl({ path: logo });
                    if (!isCancelled) setCompanyLogo(photoUrl.url.href);
                } catch (error) {
                    console.error('Error fetching image:', error);
                    Sentry.captureException(error);
                    if (!isCancelled) setCompanyLogo(DEFAULT_LOGO);
                }
                return;
            }

            if (!isCancelled) setCompanyLogo(logo);
        };

        resolveLogo();
        return () => {
            isCancelled = true;
        };
    }, [company?.logo]);

    return companyLogo;
}
